const modalAlertConstants = {
  INFO: 'MODAL_ALERT_INFO',
  INFO_GOTO_HOME: 'MODAL_ALERT_INFO_GOTO_HOME',
  INFO_RELOAD: 'MODAL_ALERT_INFO_RELOAD',
  CLEAR: 'MODAL_ALERT_CLEAR',
  CUSTOM_INFO: 'MODAL_ALERT_CUSTOM_INFO',
};

export default modalAlertConstants;
